export enum NonOwnerObjective {
    WantsToBuy = 'WantsToBuy',
    Curious = 'Curious',
    Sold = 'Sold',
    IsCurrentTenant = 'IsCurrentTenant',
    WantsToRent = 'WantsToRent',
    IsSupporter = 'IsSupporter',
}
